// Copyright (c) 2020 WiseTime. All rights reserved.

export const isDevelopmentEnv = () => process.env.NODE_ENV === "development"
export const isTestEnv = () => process.env.NODE_ENV === "test"

export const storagePrefix = "wt_timeline_"
// eslint-disable-next-line lingui/no-unlocalized-strings
export const iOSWiseTimeUserAgent = "WiseTime iOS"
export const isIosWiseTime = navigator.userAgent === iOSWiseTimeUserAgent

export const isUSDomain = (): boolean =>
  window.location.hostname.endsWith("wisetime.us")
